import React, { useState, useEffect } from "react";
import { TfiClose } from "react-icons/tfi";
import { FiMail, FiClock, FiUser, FiCalendar, FiInfo } from "react-icons/fi";
// import Style from "../../../style/Pages/chat/PopUp/ViewGroupPopUp.module.css";
import { useFetchSelectedPerson } from "../../../hooks/useUserList";
import Styles from "../../../style/Pages/PopUp/PersonQuickView.module.css";
import popupsyle from "../../../style/PopUp.module.css";
import FallbackAvatar from "../../../components/ui/FallbackAvatar/FallbackAvatar";
import formatDate from "../../../components/ui/dateFormat";

const PersonQuickView = ({ onClose, userId }) => {
  const {
    selectedUser,
    loading: userLoading,
    // refresh: refreshGroup,
  } = useFetchSelectedPerson(userId);
  const apiUrl = process.env.REACT_APP_API_URL;
  // const loggedInUserId = getRegisterId();

  const {
    first_name,
    last_name,
    email,
    about,
    emp_pic,
    active_status,
    discription,
    join_date,
    online_status,
  } = selectedUser[0] || {};

  const [currentTime, setCurrentTime] = useState("");
  // const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // setIsVisible(true);
    const updateTime = () => {
      setCurrentTime(
        new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    };

    updateTime();
    const interval = setInterval(updateTime, 60000);

    return () => clearInterval(interval);
  }, []);

  const handleClose = () => {
    // setIsVisible(false);
    onClose();
    setTimeout(onClose, 300);
  };
  const ShimmerLoader = () => (
    <div className={Styles.ShimmerContainer}>
      {/* Header Shimmer */}
      <div className={Styles.ShimmerHeader}>
        <div className={Styles.ShimmerAvatar}></div>
        <div className={Styles.ShimmerUserMeta}>
          <div className={Styles.ShimmerName}></div>
          <div className={Styles.ShimmerTitle}></div>
        </div>
      </div>

      {/* Info Grid Shimmer */}
      <div className={Styles.ShimmerInfoGrid}>
        {[...Array(4)].map((_, index) => (
          <div key={index} className={Styles.ShimmerInfoCard}>
            <div className={Styles.ShimmerIcon}></div>
            <div className={Styles.ShimmerInfoContent}>
              <div className={Styles.ShimmerLabel}></div>
              <div className={Styles.ShimmerValue}></div>
            </div>
          </div>
        ))}
      </div>

      {/* About Section Shimmer */}
      <div className={Styles.ShimmerAboutSection}>
        <div className={Styles.ShimmerSectionHeader}>
          <div className={Styles.ShimmerSectionIcon}></div>
          <div className={Styles.ShimmerSectionTitle}></div>
        </div>
        <div className={Styles.ShimmerAboutText}>
          <div className={Styles.ShimmerLine}></div>
          <div className={Styles.ShimmerLine}></div>
          <div className={Styles.ShimmerLineShort}></div>
        </div>
      </div>
    </div>
  );
  return (
    <div className={popupsyle.popupBackground} onClick={onClose}>
      <div className={Styles.MainContainer}>
        {/* Header Section */}
        {/* Info Grid Shimmer */}
        {userLoading ? (
          <ShimmerLoader />
        ) : (
          <>
            <div className={Styles.ModalHeader}>
              <div className={Styles.UserProfile}>
                <div className={Styles.AvatarWrapper}>
                  {emp_pic !== null ? (
                    <img
                      src={`${apiUrl}${emp_pic}`}
                      alt={`${first_name} ${last_name}`}
                      className={Styles.AvatarImage}
                    />
                  ) : (
                    <FallbackAvatar name={first_name} size={40} />
                  )}

                  {online_status && <span className={Styles.OnlineDot}></span>}
                </div>

                <div className={Styles.UserMeta}>
                  <h2
                    className={Styles.UserName}
                  >{`${first_name} ${last_name}`}</h2>
                  {/* <p className={Styles.UserTitle}>Team Member</p> */}
                </div>
              </div>

              <div className={Styles.HeaderActions}>
                {/* <button className={Styles.ActionButton}>
              <PiDotsThreeOutlineVerticalThin size={20} />
            </button> */}
                <button className={Styles.CloseButton} onClick={handleClose}>
                  <TfiClose size={18} />
                </button>
              </div>
            </div>

            {/* Content Section */}
            <div className={Styles.ModalContent}>
              {/* Main Information Cards */}
              <div className={Styles.InfoGrid}>
                <div className={Styles.InfoCard}>
                  <div className={Styles.InfoIcon}>
                    <FiMail size={18} />
                  </div>
                  <div>
                    <h4 className={Styles.InfoLabel}>Email</h4>
                    <p className={Styles.InfoValue}>
                      {email || "Not provided"}
                    </p>
                  </div>
                </div>

                <div className={Styles.InfoCard}>
                  <div className={Styles.InfoIcon}>
                    <FiClock size={18} />
                  </div>
                  <div>
                    <h4 className={Styles.InfoLabel}>Local Time</h4>
                    <p className={Styles.InfoValue}>{currentTime}</p>
                  </div>
                </div>

                <div className={Styles.InfoCard}>
                  <div className={Styles.InfoIcon}>
                    <FiCalendar size={18} />
                  </div>
                  <div>
                    <h4 className={Styles.InfoLabel}>Member Since</h4>
                    <p className={Styles.InfoValue}>
                      {join_date ? formatDate(join_date) : "Unknown"}
                    </p>
                  </div>
                </div>

                <div className={Styles.InfoCard}>
                  <div className={Styles.InfoIcon}>
                    <FiUser size={18} />
                  </div>
                  <div>
                    <h4 className={Styles.InfoLabel}>Status</h4>
                    <p className={Styles.InfoValue}>
                      {active_status ? "Active" : "Inactive"}
                    </p>
                  </div>
                </div>
              </div>

              {/* About Section */}
              {(about || discription) && (
                <div className={Styles.AboutSection}>
                  <div className={Styles.SectionHeader}>
                    <FiInfo size={18} className={Styles.SectionIcon} />
                    <h3 className={Styles.SectionTitle}>About</h3>
                  </div>
                  <p className={Styles.AboutText}>
                    {about || discription || "No information provided"}
                  </p>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PersonQuickView;
